module.exports = __webpack_public_path__ + "static/media/group-of-question-marks.ba4db863.svg";